export enum FlowsLaunchDarklyFeatureFlags {
  ROUTING_INFORMATION = 'match-flow-routing-information',
  MATCH_FLOW_SLUG = 'match-flow-slug',
  MATCH_FLOW_SPACING = 'mf-spacing-optimization',
  MATCH_FLOW_CALL_COMPONENT = 'match-flow-call-component',
}
